import PropTypes from 'prop-types';
import React from 'react';

import DetailsTile from '@react/Pages/AccountSettingsPage/YourDataSection/DetailsTile/DetailsTile';
import {
  TileWithLoading,
  tileWithLoadingPropTypes,
} from '@react/Pages/AccountSettingsPage/YourDataSection/TileWithLoading';

const mapLangCodeToLocalizedString = langCode =>
  ({
    en: t('language.english'),
    ja: t('language.japanese'),
    zh: t('language.chinese-simplified'),
    ko: t('language.korean'),
    vi: t('language.vietnamese'),
    ru: t('language.russian'),
    pt: t('language.portuguese.brazil'),
    es: t('language.spanish'),
    tr: t('language.turkish'),
    fr: t('language.french'),
  }[langCode]);

const mapRoleToLocalizedString = role =>
  ({
    admin: t('role.admin'),
    editor: t('role.editor'),
    reader: t('role.reader'),
    custom: t('role.custom'),
  }[role]);

const UserDetailsTileBase = ({ user, dateTime, href }) => {
  const { full_name, email, language, role } = user;
  const { time, timezone } = dateTime;

  const fields = [
    {
      title: t('label.name'),
      values: [full_name],
      icon: 'icon-user-outline',
    },
    {
      title: t('label.email'),
      values: [email],
      icon: 'icon-email',
    },
    {
      title: t('label.language'),
      values: [mapLangCodeToLocalizedString(language)],
      icon: 'icon-language',
    },
    {
      title: t('label.user-time-zone'),
      values: [timezone, time],
      icon: 'icon-clock',
    },
    {
      title: t('label.role'),
      values: [mapRoleToLocalizedString(role)],
      icon: 'icon-access',
    },
  ];

  return <DetailsTile title={t('label.user-details')} href={href} fields={fields} />;
};

UserDetailsTileBase.propTypes = {
  user: PropTypes.shape({
    full_name: PropTypes.string,
    email: PropTypes.string,
    language: PropTypes.string,
    authentication_token: PropTypes.string,
  }),
  dateTime: PropTypes.shape({
    time: PropTypes.string,
    timezone: PropTypes.string,
  }),
  href: PropTypes.string,
};

const UserDetailsTile = TileWithLoading(UserDetailsTileBase);

UserDetailsTile.propTypes = {
  ...UserDetailsTileBase.propTypes,
  ...tileWithLoadingPropTypes,
};

export default UserDetailsTile;
export { UserDetailsTile, UserDetailsTileBase };
